<template>
  <PopOver :label="$t('header.help')">
    <div class="help">
      <div class="label">{{ $t("header.contact_support") }}</div>
      <div v-if="supportNumber" class="label">
        <img src="@/assets/images/telephone.png" />
        <span class="value">{{ supportNumber }}</span>
      </div>
      <div class="label">
        <img src="@/assets/images/email.png" />
        <span class="value email-link" @click="openTechSupport">{{
          $t("header.email_us")
        }}</span>
      </div>
    </div>
  </PopOver>
</template>


<script setup>
import PopOver from "@/components/common/PopOver/PopOver.vue";
import { OpenTechSupportForm } from "@/utils/helper";

// Define component name
defineOptions({
  name: 'help-box'
});

// Props
defineProps({
  supportNumber: { 
    type: String, 
    default: "" 
  },
});

// Methods
const openTechSupport = () => {
  OpenTechSupportForm();
};
</script>

<style lang="stylus" scoped>
.help {
  width: 16.06rem;
  display: flex;
  flex-direction: column;
  border: 1px solid #CFCFCF;
  border-top: 3px solid #DDDDDD;
  padding: 12px 15px 0px 15px;
  box-sizing: border-box;
  font-size: 14px;
  align-items: flex-start;

  .label {
    line-height: 20px;
    color: #1D3649;
    flex: none;
    flex-grow: 0;
    margin-bottom: 18px;

    img {
      margin-right: 10px;
    }

    .value {
      vertical-align: text-bottom;  
    }
    
    .email-link {
      color: #2A40FC;
      cursor: pointer;
    }
  }
}
</style>


